import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
//import Vue2TouchEvents from 'vue2-touch-events'
import VueWaypoint from 'vue-waypoint'
//import VueProgressiveImage from 'vue-progressive-image'
import VueClipboard from 'vue-clipboard2'
import imageMixins from "./mixins/images"
import VueI18n from "vue-i18n"

Vue.mixin(imageMixins)


VueClipboard.config.autoSetContainer = true;// add this line
Vue.use(VueClipboard);
Vue.use(VueI18n);

//Placeholder for images
//Vue.use(VueProgressiveImage);

// Waypoint plugin
Vue.use(VueWaypoint);

import { languages } from './locales/index.js'
import { defaultLocale } from './locales/index.js'
const messages = Object.assign(languages)

var i18n = new VueI18n({
  locale: defaultLocale,
  fallbackLocale: 'es',
  messages
})
//Swipe
/*Vue.use(Vue2TouchEvents,{
  touchClass: '',
  tapTolerance: 10,
  swipeTolerance: 30,
  longTapTimeInterval: 400
});*/
require('vue2-animate/dist/vue2-animate.min.css');

Vue.config.productionTip = false



new Vue({
  router,
  i18n,
  store,
  render: h => h(App)
}).$mount('#app');





